<template>
	<div class="header-search">
		<a
			href="#"
			class="search-toggle"
			@click.prevent="searchToggle"
		>
			<i class="icon-search"></i>
		</a>
		<form
			action="#"
			method="get"
			@click.stop="showSearchForm"
			@submit.prevent="submitSearchForm"
		>
			<div class="header-search-wrapper">
				<label
					for="q"
					class="visually-hidden-focusable"
				>Search</label>
				<input
					type="text"
					class="form-control"
					autocomplete="off"
					name="q"
					id="q"
					placeholder="Search products"
					required
					v-model="searchTerm"
					@input="searchProducts"
				/>
			</div>

			<div class="live-search-list">
				<div
					class="autocomplete-suggestions"
					v-if="suggestions.length > 0"
					@click="goProductPage"
				>
					<nuxt-link
						:to="'/product/'+ product.product_categories[0].slug  +'/' + product.slug"
						class="autocomplete-suggestion"
						data-index="0"
						v-for="product in suggestions"
						:key="product.id"
					>
						<img
							:src="`${config.public.storageDomain}${product.pictures[0]?.formats.small.url}`"
							alt="Product"
							width="40"
							height="40"
							class="product-image"
						/>
						<!-- <img                        
							v-lazy="`${baseUrl}${product.pictures[0].formats.small.url}`"
							alt="`${product.name}`"
							:width="product.pictures[0].formats.small.width"
							:height="product.pictures[0].formats.small.height"
							class="product-image"                    
						/> -->

						<div
							class="search-name"
							v-html="matchEmphasize(product.name)"
						></div>
						<span class="search-price">
							<div
								class="product-price mb-0"
								v-if="product.minPrice == product.maxPrice"
							>R{{ product.minPrice?.toFixed(2) }}</div>
							<template v-else>
								<div
									class="product-price mb-0"
									v-if="product.variants.length == 0"
								>
									<span class="new-price">R{{ product.minPrice?.toFixed(2) }}</span>
									<span class="old-price">R{{ product.maxPrice?.toFixed(2) }}</span>
								</div>
								<div
									class="product-price mb-0"
									v-else
								>R{{product.minPrice?.toFixed(2)}} - R{{product.maxPrice?.toFixed(2)}}</div>
							</template>
						</span>
					</nuxt-link>
				</div>
			</div>
		</form>
	</div>
</template>

<script setup lang="ts">
	import { useCartStore } from '@/stores/cart'
	import { useWishlistStore } from '@/stores/wishlist'
	import { useCompareStore } from '@/stores/compare'

	const router = useRouter()
	const config = useRuntimeConfig()
	const cartStore = useCartStore()
	const compareStore = useCompareStore()
	const wishlistStore = useWishlistStore()

	let searchTerm = ref('')
	let suggestions = ref([])
	let timeouts = []
	
	onMounted( () => {
		document
			.querySelector('body')
			.addEventListener('click', closeSearchForm);
	})
		
	const searchProducts = () => {
			if (searchTerm.value.length > 1) {
				// var searchTerm = searchTerm;
				timeouts.map(timeout => {
					window.clearTimeout(timeout);
				});
				timeouts.push(
					setTimeout(() => {
						useFetch(`/api/search`, {
							baseURL: config.public.baseCMSDomain,
							method: 'GET',
            				initialCache: false,
							headers: {
                    			'Content-Type': 'application/json',
                    			Authorization: `Bearer ${config.public.cmsToken}`
                			},						
							params: {
								searchTerm: searchTerm.value
							}
						})
						.then(response => {
							suggestions.value = response.data.value.reduce(
								(acc, cur) => {
									let max = 0;
									let min = 99999;
									//console.debug("Product name: '"+ cur.name +"");
									cur.variants.map(item => {
										if (min > item.price)
											min = item.price;
										if (max < item.price)
											max = item.price;
									}, []);

									if ((cur.variants.length == 0) || (cur.variants[0]?.price == null)) {
										min = cur.sale_price
											? cur.sale_price
											: cur.price;
										max = cur.price;
									}
									return [
										...acc,
										{
											...cur,
											minPrice: min,
											maxPrice: max
										}
									];
								},
								[]
							);
						})
						.catch(error => { console.debug(error)});
					}, 400)
				);
			} else {
				timeouts.map(timeout => {
					window.clearTimeout(timeout);
				});
				suggestions.value = [];
			}
		}

		const matchEmphasize = (name) => {
			var regExp = new RegExp(searchTerm.value, 'i');
			return name.replace(
				regExp,
				match => '<strong>' + match + '</strong>'
			);
		}

		const goProductPage = () => {
			searchTerm.value = '';
			suggestions.value = [];
		}

		const searchToggle = (e) => {
			document
				.querySelector('.header-search-wrapper')
				.classList.toggle('show');
			document.getElementById("q").focus();
			e.stopPropagation();
		}

		const showSearchForm = () => {
			document
				.querySelector('.header .header-search')
				.classList.add('show');
		}

		const closeSearchForm = (e) => {
			document
				.querySelector('.header .header-search')
				.classList.remove('show');
		}

		const submitSearchForm = (e) => {
			closeSearchForm(e);
			router.push({
				path: '/shop/nosidebar/fullwidth',
				query: {
					searchTerm: searchTerm.value
				}
			});
			searchTerm.value = '';
		}
</script>